import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./paytronix_check_number_source.js";
//#region src/paytronix_check_number_source_helper.ts
var paytronix_check_number_source_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(source) {
	switch (source) {
		case "bite": return "Bite";
		case "pos": return "Point of Sale";
	}
}
//#endregion
export { name, paytronix_check_number_source_helper_exports };

//# sourceMappingURL=paytronix_check_number_source_helper.js.map